import { render, staticRenderFns } from "./lookup-widget.vue?vue&type=template&id=3e48c1f7&scoped=true"
import script from "./lookup-widget.vue?vue&type=script&lang=js"
export * from "./lookup-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48c1f7",
  null
  
)

export default component.exports